/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IKit  {
        id: number;
        status: string;
    }

    export class Kit implements IKit {
        public id: number;
        public status: string;


        public static Empty(): Kit {
            return new Kit();
        }

        public static Copy(kit: Kit): Kit {
            let newKit: Kit = new Kit();
            newKit.id = kit.id;
            newKit.status = kit.status;
            return newKit;
        }

        constructor() {
            // empty constructor
            this.status = "";
            this.id = undefined;
        }


    }
}
